import Component from "../../../../js/assets/component.js"

class AirHotelsSelectBlock extends Component{
  constructor(selector) {
    // set root element
    super(selector)
  }
  
  data() {
    return {
      "activeHotelId": 0
    }
  }

  changed() {
    return {
      "activeHotelId": (val, prev) => {
        this.changeHotel(val)
      }
    }
  }

  changeHotel(hotelId) {
    this.rooms.forEach((elm) => {
      if (elm.id === `airHotelsSelectBlock-${hotelId}`) {
        elm.classList.remove("-inactive")
        elm.classList.add("-active")
      } else {
        elm.classList.remove("-active")
        elm.classList.add("-inactive")
      }
    })
  }

  // can access this.el or this.$el
  mounted() {
    // ホテル選択ラジオボタンのリスト。
    this.hotels = this.el.querySelectorAll(":scope input[name=hotel]")
    this.rooms = this.el.querySelectorAll(":scope [id^=airHotelsSelectBlock]")

    this.hotels.forEach((elm) => {
      elm.addEventListener("change", (event) => {
        this.$data.activeHotelId = event.target.value
      })
    })

    // ページ表示時点の選択ホテルを覚える
    this.hotels.forEach((elm) => {
      if (elm.classList.contains("-active")) {
        this.$data.activeHotelId = elm.value
      }
    })
  }
}

// export as singleton
const instance = new AirHotelsSelectBlock("#airHotelsSelectBlock")
// Object.seal(instance)
export default instance
